import { ID } from "../core/id";
export type NotiflyType = "order_change_status" | "order_problem" | "order_success" | "order_paing" | "jobs_pay" | "job_worked" | "job_revied" | "job_fixed" | "job_close";

export interface NotiflyOptions {
  telegram: NotiflySetting[];
  email: NotiflySetting[];
}
export interface NotiflySetting {
  type: NotiflyType;
  enabled: boolean;
  is_change: boolean;
}
export interface NotiflySettings {
  id: ID;
  user_id: ID;
  options: NotiflyOptions;
  date_modified: number;
  date_published: number;
}


export const TextSettingsTelegram: Record<NotiflyType, { text: string, desc: string }> = {
  order_change_status: {
    text: "Изменения статуса",
    desc: "Увидите каждое изменение по заказу",
  },
  order_problem: {
    text: "Проблема с заказом",
    desc: "Сможем оперативно решить проблему",
  },
  order_success: {
    text: "Заказ выполнен",
    desc: "Подскажем когда выполним все задания",
  },
  order_paing: {
    text: "Заказ не оплачен",
    desc: "Напомним оплатить",
  },
  job_worked: {
    text: "Задание сделано",
    desc: "Скажем когда выполнит исполнитель",
  },
  job_revied: {
    text: "Задание проверено",
    desc: "Скажем если успешно проверено",
  },
  job_fixed: {
    text: "Правки внесены",
    desc: "Скажем когда исполнитель внесет правки",
  },
  job_close: {
    text: "Заказ закрыт",
    desc: "Скажем когда заказ закроется",
  },
  jobs_pay: {
    text: "Оплатить задания",
    desc: "Напомним оплатить",
  },
}